module.exports = __webpack_public_path__ + "static/media/greeting_card_1.685f9632.png";